const TETROMINOES = {
    I: [
      [0, 1, 0, 0],
      [0, 1, 0, 0],
      [0, 1, 0, 0],
      [0, 1, 0, 0]
    ],
    L: [
      [0, 1, 0],
      [0, 1, 0],
      [0, 1, 1]
    ],
    J: [
      [0, 1, 0],
      [0, 1, 0],
      [1, 1, 0]
    ],
    O: [
      [1, 1],
      [1, 1]
    ],
    Z: [
      [1, 1, 0],
      [0, 1, 1],
      [0, 0, 0]
    ],
    S: [
      [0, 1, 1],
      [1, 1, 0],
      [0, 0, 0]
    ],
    T: [
      [0, 1, 0],
      [1, 1, 1],
      [0, 0, 0]
    ]
  };
  
  const COLORS = {
    I: '#FFDA27',
    O: '#DB29FF',
    T: '#DB29FF',
    S: '#4DFF29',
    Z: '#294DFF',
    J: '#294DFF',
    L: '#FFDA27'
  };
  
  export const createBoard = (rows = 20, cols = 10) => {
    return Array.from({ length: rows }, () => Array(cols).fill(0));
  };
  
  export const randomTetromino = () => {
    const shapes = Object.keys(TETROMINOES);
    const shape = shapes[Math.floor(Math.random() * shapes.length)];
    return {
      shape,
      matrix: TETROMINOES[shape],
      color: COLORS[shape],
      pos: { x: 3, y: 0 }
    };
  };
  
  export const checkCollision = (board, tetromino, pos) => {
    for (let y = 0; y < tetromino.matrix.length; y++) {
      for (let x = 0; x < tetromino.matrix[y].length; x++) {
        if (tetromino.matrix[y][x]) {
          const newX = x + pos.x;
          const newY = y + pos.y;
          
          if (
            newX < 0 ||
            newX >= board[0].length ||
            newY >= board.length ||
            (newY >= 0 && board[newY][newX])
          ) {
            return true;
          }
        }
      }
    }
    return false;
  };
  
  export const rotateTetromino = (matrix) => {
    const N = matrix.length;
    const rotated = matrix.map((row, i) =>
      row.map((val, j) => matrix[N - 1 - j][i])
    );
    return rotated;
  };
  
  export const mergeTetromino = (board, tetromino) => {
    const newBoard = board.map(row => [...row]);
    tetromino.matrix.forEach((row, y) => {
      row.forEach((value, x) => {
        if (value) {
          const newY = y + tetromino.pos.y;
          const newX = x + tetromino.pos.x;
          if (newY >= 0) {
            newBoard[newY][newX] = tetromino.color;
          }
        }
      });
    });
    return newBoard;
  };
  
  export const clearLines = (board) => {
    let lines = 0;
    const newBoard = board.filter(row => {
      const isFull = row.every(cell => cell !== 0);
      if (isFull) lines++;
      return !isFull;
    });
    
    while (newBoard.length < board.length) {
      newBoard.unshift(Array(board[0].length).fill(0));
    }
    
    return { newBoard, lines };
  };
  
  export const normalizeTetrominoPreview = (matrix) => {
    const normalized = Array(2).fill().map(() => Array(4).fill(0));
    
    switch (matrix.length) {
      case 4: 
        normalized[0][0] = matrix[0][1];
        normalized[0][1] = matrix[1][1];
        normalized[0][2] = matrix[2][1];
        normalized[0][3] = matrix[3][1];
        break;
      
      case 3: 
        if (matrix[0][0] === 1) { 
          normalized[0][0] = 1;
          normalized[0][1] = 1;
          normalized[0][2] = 1;
          normalized[1][2] = 1;
        } else if (matrix[2][0] === 1) { 
          normalized[0][0] = 1;
          normalized[0][1] = 1;
          normalized[0][2] = 1;
          normalized[1][0] = 1;
        } else if (matrix[1][0] === 1) { 
          normalized[0][0] = 1;
          normalized[0][1] = 1;
          normalized[0][2] = 1;
          normalized[1][1] = 1;
        } else if (matrix[0][0] === 0) { 
          normalized[0][1] = 1;
          normalized[0][2] = 1;
          normalized[1][0] = 1;
          normalized[1][1] = 1;
        } else { 
          normalized[0][0] = 1;
          normalized[0][1] = 1;
          normalized[1][1] = 1;
          normalized[1][2] = 1;
        }
        break;
      
      case 2: 
        normalized[0][0] = matrix[0][0];
        normalized[0][1] = matrix[0][1];
        normalized[1][0] = matrix[1][0];
        normalized[1][1] = matrix[1][1];
        break;
      
      default:
        break;
    }
    
    return normalized;
  };